"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryParamStr = exports.getQueryParams = exports.getBodyParams = void 0;

var _immutable = require("immutable");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _params = require("hub-http/helpers/params");

var getBodyParams = (0, _memoize.default)(function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  return (0, _immutable.Map)({
    formSubmissionMode: ['none'],
    identityProfileMode: ['all'],
    propertyMode: ['value_only'],
    resolveAssociations: [false],
    resolveOwner: [false],
    showAnalyticsDetails: [false],
    showListMemberships: [options.get('showListMemberships')],
    showPastListMemberships: [false],
    showPublicToken: [false],
    showSourceMetadata: [false]
  });
});
exports.getBodyParams = getBodyParams;
var getQueryParams = (0, _memoize.default)(function (options) {
  return getBodyParams(options).map(function (value) {
    return value[0];
  });
});
exports.getQueryParams = getQueryParams;
var getQueryParamStr = (0, _memoize.default)(function (options) {
  return (0, _params.stringify)(getQueryParams(options).toJS());
});
exports.getQueryParamStr = getQueryParamStr;